import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';

import styles from './CancellationPolicy.module.scss';

export type CancellationPolicyProps = {
  days: number;
  percent: number;
};

const CancellationPolicy: FC<CancellationPolicyProps> = ({
  days,
  percent,
}) => {
  const [t] = useTranslation('listing-page');

  if (!days || !percent) {
    return null;
  }

  return (
    <div className={styles.root}>
      <h3 className={styles.subTitle}>
        {t('cancellation-policy--title')}
      </h3>
      <p className={styles.description}>
        {t('cancellation-policy--description', {
          context: percent === 100 ? 'full' : 'percent',
          count: days,
          percent,
        })}
      </p>
    </div>
  );
};

export default CancellationPolicy;
